module.exports = __webpack_public_path__ + "img/howto4.81177323.png";